import React, { useCallback, useContext, useEffect, useState } from 'react';
import { LoadingContext } from './context/LoadingContext';
import { ToastContext } from './context/ToastContext';
import { Link } from 'react-router-dom';

import '../styles/BrandList.css';

const HomeBrands = () => {
    const [brandList, setBrandList] = useState([]);
    const [loading, setLoading] = useState(true);
    const { sendMessage } = useContext(ToastContext);
    const {
        startLoading,
        finishLoading,
    } = useContext(LoadingContext);
    const fetchBrands = useCallback(async () => {
        try {
            startLoading();
            setLoading(true);
            const url = new URL('/api/products/vendors', process.env.APP_URL);
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            const data = await response.json();
            setBrandList(data.vendors ?? []);
        } catch (e) {
            sendMessage(e.message, 'danger');
        } finally {
            finishLoading();
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchBrands();
    }, []);
    return (
        <div>
            <h5
                className={'dotted-background'}
            >
                POPULAR BRANDS
            </h5>
            <div
                className={'brand-list-container'}
            >
                {loading && <div
                    className={'text-center'}>Loading...</div>}
                {brandList.map((brand, index) => (
                    <div
                        key={`${brand}-${index}`}
                        className={'px-3 py-2 brand-list--item'}>
                        <Link
                            to={`/brands/${encodeURIComponent(brand)}`}
                            className={'default-link'}>
                            {brand}
                        </Link>
                    </div>
                ))}
                <div
                    className={'px-3 pt-2 brand-list--view-all'}>
                    <Link
                        to={'/brands'}>
                        <b>
                            View All Brands
                        </b>
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default HomeBrands;